import { checkLogin } from '@/api/api_comm';

const state = {
  isLoggedIn: false,
  hpUserId: '',
  userId: '',
  userName: '',
  userEmail: '',
  userMobileNum: '',
  userBirthDay: '',
};

const mutations = {
  UPDATE_LOGIN_STATUS(state, payload) {
    state.isLoggedIn = payload.isLoggedIn;
    state.hpUserId = payload.hpUserId;
    state.userId = payload.userId;
    state.userName = payload.userName;
    state.userEmail = payload.userEmail;
    state.userMobileNum = payload.userMobileNum;
    state.userBirthDay = payload.userBirthDay;
  },
};
const actions = {
  async checkUserLogin({ commit }) {
    const data = await checkLogin();
    if (data.success) {
      //console.log(data.response);
      commit('UPDATE_LOGIN_STATUS', data.response);
    }
  },
};

const getters = {
  isLoggedIn(state) {
    return state.isLoggedIn;
  },
};

const productModule = {
  state,
  mutations,
  actions,
  getters,
};

export default productModule;
